import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {RoadtripDetailsPageModule} from '../roadtrip-details/roadtrip-details-page.module';
import {StepDetailsPage} from './step-details';

@NgModule({
  declarations: [
    StepDetailsPage
  ],
  imports: [
    RoadtripDetailsPageModule,
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule
  ],
})
export class StepDetailsModule {
}
